import React, { createContext, useContext } from 'react';

const featureFlags = {
  phase1: process.env.REACT_APP_FEATURE_PHASE1 === 'true',
  phase2: process.env.REACT_APP_FEATURE_PHASE2 === 'true',
  phase3: process.env.REACT_APP_FEATURE_PHASE3 === 'true',
};

const FeatureFlagsContext = createContext(featureFlags);

export const FeatureFlagsProvider = ({ children }) => (
  <FeatureFlagsContext.Provider value={featureFlags}>
    {children}
  </FeatureFlagsContext.Provider>
);

export const useFeatureFlags = () => useContext(FeatureFlagsContext);

export default FeatureFlagsContext;
